/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-12 17:35:34
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2022-06-29 14:50:34
 * @Content:
 */

import React, { FC, memo, ReactNode } from "react";
import Modal from "../../../components/Common/Modal/Modal";
import "./index.less";
import gamblingModalCloseIcon from "../../../assets/imgs/gamblingModalCloseIcon.png";
import gamblingModalLeftQuoteIcon from "../../../assets/imgs/gamblingModalLeftQuoteIcon.png";
import gamblingModalRightQuoteIcon from "../../../assets/imgs/gamblingModalRightQuoteIcon.png";
import classNames from "classnames";

const PREFIX = "GamblingEndModal";

type IProps = {
  visible: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
  /* 底部按钮 */
  footerBtnText?: string; // 底部按钮文案（如果不传，则不显示底部按钮）
  onFooterBtnClick?: () => void; // 底部按钮点击
};

const GamblingEndModal: FC<IProps> = memo(
  ({
    visible,
    onClose,
    children,
    className,
    footerBtnText,
    onFooterBtnClick,
  }) => {
    return (
      <Modal
        visible={visible}
        animation="fade"
        onClose={onClose}
        className={classNames(PREFIX, className)}
      >
        <div className={`${PREFIX}-body`}>
          {/* 关闭按钮 */}
          <div className={`${PREFIX}-bodyClose`} onClick={onClose}>
            <img src={gamblingModalCloseIcon} />
          </div>
          {/* 标题 */}
          <div className={`${PREFIX}-bodyTitle`}>本次活动已结束</div>
          {/* 分隔线 */}
          <div className={`${PREFIX}-bodyDivider`}></div>
          {/* 内容 */}
          <div className={`${PREFIX}-bodyContent`}>
            <img
              src={gamblingModalLeftQuoteIcon}
              className={`${PREFIX}-bodyContentLeftIcon`}
            />
            <img
              src={gamblingModalRightQuoteIcon}
              className={`${PREFIX}-bodyContentRightIcon`}
            />
            <div className={`${PREFIX}-bodyContentChildren`}>{children}</div>
          </div>
          {/* 底部按钮 */}
          {footerBtnText ? (
            <div className={`${PREFIX}-bodyFooter`}>
              <div
                className={`${PREFIX}-bodyFooterBtn`}
                onClick={onFooterBtnClick}
              >
                {footerBtnText}
              </div>
            </div>
          ) : null}
        </div>
      </Modal>
    );
  }
);

export default GamblingEndModal;
